import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, UiClientSelect, BgLoader, UiButton, OverlayLoader } from "../ui";


const ReportSend = NiceModal.create(
  ({ type, action, ids }) => {
    const [state, setState] = useState({ count: 0 });
    const modal = useModal();
    const [loader, showLoader] = useState(false);

    const schema = yup.object().shape({
      type: yup.string(),
      staff: yup.mixed().required('Staff is required'),
    

      
    }, []);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {

      modal.resolve({ resolved: true, staff: e.staff });
      modal.hide();

  


    };





    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>{type} Share</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={loader} />
        <BootstrapModal.Body>

          <form id="waform" onSubmit={handleSubmit(onSubmitHandler)}>
          <Controller
                      name={`staff`}
                      control={control}
                      render={({ field }) => (

                        <UiClientSelect
                          {...field}
                          parentClass="mb-1"
                          className=""
                          category={[26]}
                          fetch_onload
                          required
                          message={errors.staff?.message}
                          label="Staff"

                        />

                      )}
                    />
            <UiInput type="hidden" name="type" value={type} {...register(`type`)} />
            <UiButton className="btn btn-primary" type="submit" title={"Send on Whatsapp"} />

          </form>

        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default ReportSend;
